{{ price | number: '1.2' }}
